const checkIfInputContainsLettersOrNull = (input: string) => {
    if (!input) {
        return true;
    }
    const regex = /[A-Za-z]/g;
    return input.match(regex)?.length > 0

}

const trimEnd = (str: string, charToRemove: string) => {
    if (!str) {
        return str;
    }
    let index = str.length - 1;
    while (str[index] === charToRemove) {
        index--;
    }
    return str.substring(0, index + 1);
}


export {
    checkIfInputContainsLettersOrNull,
    trimEnd
}